// tslint:disable
import * as React from 'react'
import Request, { PROD_URL } from '@/utils/request'
import HttpServer from '@/services/server'
import { isTest, getUrlParam } from '@/utils/tools'
import globalBus from '@/services/Bus'
import './HomeActiveCouponStyle'

interface HomeActiveCouponState {
  beginShowTime: boolean // 标识动效是否执行完成，动效结束后才显示关闭的按钮
  isDialogShow: boolean // 是否展示弹窗
  window_id: number // 弹窗id
  strategy_id: number // 策略id
  window_style_id: number // 弹窗下的样式id
  image_url: string // 图片url
  activity_url: string // 跳转链接活动url
}
interface Iprops {
  window_id: number
  window_style_id: number
  strategy_id: number
  scene: string
  image_url: string
  activity_url: string
}
interface Idata {
  window_id: number
  window_style_id: number
  strategy_id: number
  scene: string
  image_url: string
  activity_url: string
}
export default class NewHomeActiveCoupon extends React.Component<Iprops, HomeActiveCouponState> {
  private headerRefs: React.RefObject<HTMLDivElement>
  constructor(props: any) {
    super(props)
    this.state = {
      beginShowTime: false,
      isDialogShow: false,
      window_id: 0,
      strategy_id: 0,
      window_style_id: 0,
      image_url: '',
      activity_url: ''
    }
    this.headerRefs = React.createRef()
  }

  public componentDidMount() {
    // this.fetchCoupon()
    this.setState({
      window_id: this.props.window_id,
      window_style_id: this.props.window_style_id,
      strategy_id: this.props.strategy_id,
      image_url: this.props.image_url,
      activity_url: this.props.activity_url
    })
    this.recordPopWindowCoupon('impress')
    // 访问红包弹窗埋点
    try {
      if ((window as any).TorDataService) {
        (window as any).TorDataService.emitAction('hp_popup_show', {
          id: this.props.window_id,
          url: this.props.activity_url,
          index: this.props.window_style_id,
          img_url: this.props.image_url
        })
      }
    } catch (error) {
      console.log(error)
    }
    setTimeout(() => {
      this.popDialog()
    }, 0)
  }

  // 获取弹窗数据
  public fetchCoupon() {
    Request.$get(`${isTest() ? location.origin : PROD_URL}/popwindow/new_popwindow/api/get_window_info`, { params: { scene: 'index', item_type: 'wk' } }).then(res => {
      const result = res.data.data
      if (res.data.code === 0 && Object.keys(result).length) {
        // 不需要显示弹窗data会返回空对象
        this.setState({
          window_id: result.window_id,
          strategy_id: result.strategy_id,
          window_style_id: result.window_style_id,
          image_url: result.image_url,
          activity_url: result.activity_url
        })
        this.recordPopWindowCoupon('impress')
        this.popDialog()
      }
    })
  }

  // 监听动效执行结束
  public popDialog() {
    this.setState({ isDialogShow: true }) // 显示弹窗
    if (this.headerRefs.current && this.headerRefs.current !== null) {
      this.headerRefs &&
        this.headerRefs.current.addEventListener('webkitAnimationEnd', () => {
          this.setState({ beginShowTime: true })
        })
    }
  }

  // 拆弹窗红包
  public onClickDialog(e: any = null) {
    // 点击红包弹窗埋点
    try {
      if ((window as any).TorDataService) {
        (window as any).TorDataService.emitAction('hp_popup_click', {
          id: this.props.window_id,
          url: this.props.activity_url,
          index: this.props.window_style_id,
          img_url: this.props.image_url
        })
      }
    } catch (error) {
      console.log(error)
    }
    if (e) {
      e.stopPropagation()
    }
    this.recordPopWindowCoupon('click')
    this.setState({ isDialogShow: false })
    this.userAction('click')
    setTimeout(() => {
      location.assign(this.state.activity_url)
    }, 200)
  }

  // 用户行为埋点(click/view)
  public recordPopWindowCoupon(type: 'click' | 'impress') {
    const { strategy_id, window_style_id, activity_url } = this.props;
    const scene = getUrlParam('scene') ? `.${getUrlParam('scene')}` : ''
    try {
      HttpServer.reportServerAPI([
        {
          ubt: `wk.opu2${scene}-home.popup__${strategy_id}_${window_style_id}`,
          evt: type,
          evt_params: {
            url: activity_url
          }
        }
      ])
    } catch (e) {
      console.log(e)
    }
  }

  // 用户行为记录：后台需要记录如果用户关闭了弹窗没有拆那么下次再进来还要给他弹
  public userAction(action: 'click' | 'cancel') {
    const params = {
      action: action,
      scene: 'index',
      window_id: this.state.window_id
    }
    Request.$get(`${isTest() ? location.origin : PROD_URL}/popwindow/new_popwindow/api/user_action`, { params })
  }

  // 关闭弹窗
  public onCloseDialog = (e: any = null) => {
    e.stopPropagation()
    this.userAction('cancel')
    // this.openDialog()
    this.setState({ isDialogShow: false })
  }

  // 挽留弹窗(点击关闭按钮或者遮罩层会触发挽留弹窗)
  // public openDialog = () => {
  //   globalBus.emit({
  //     dialogInfo: {
  //       isShow: true,
  //       title: '真的要放弃专属大额红包吗',
  //       subTitle: '仅此一次机会，关闭后不可再次领取',
  //       fn: [
  //         {
  //           tag: 'cancel',
  //           name: '残忍拒绝',
  //           fn: () => {
  //             globalBus.emit({ dialogInfo: { isShow: false } })
  //           }
  //         },
  //         {
  //           tag: 'success',
  //           name: '我要领取',
  //           fn: () => {
  //             globalBus.emit({ dialogInfo: { isShow: false } })
  //             this.onClickDialog(null)
  //           }
  //         }
  //       ]
  //     }
  //   })
  // }

  public componentWillUnmount() {
    //
  }

  public render() {
    if (this.state.isDialogShow) {
      return (
        <div className="mainactive__coupon" onClick={e => this.onCloseDialog(e)}>
          <div className="coupon__img" style={{ marginTop: '-50px' }} ref={this.headerRefs} onClick={e => this.onClickDialog(e)}>
            <img src={this.state.image_url} alt="弹窗红包" />
            <div className="coupon__close" style={{ opacity: this.state.beginShowTime ? 1 : 0 }}>
              <img src="https://static-cos.lycheer.net/picture/7931794_0b01d709a9a40d4365bf516840205510.jpg" alt="" onClick={e => this.onCloseDialog(e)} />
            </div>
          </div>
        </div>
      )
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeActiveCoupon/NewHomeActiveCoupon.tsx